var ctx = jQuery('#resultChart');
if(ctx.length){
    var chart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            datasets: [{
                label: "Month",
                backgroundColor: '#FFFFFF',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }]
        },
        options: {
            tooltips: {
                displayColors: false,
                backgroundColor: "#e1e31c",
                titleFontColor: "#000000",
                bodyFontColor: "#000000",
                titleFontSize: 16,
                bodyFontSize: 14,
                callbacks: {
                    title: function() {
                        return "";
                    },
                    label: function(item, data) {
                        let dataLabel = data.datasets[item.datasetIndex].label || "";
                        let dataPoint = formatNum(+item.yLabel);
                        return `${dataLabel} ${item.xLabel}: ${dataPoint}`;
                    }
                }
            },
            legend: {
                display: false
            },
            scales: {
                yAxes: [{
                    ticks: {
                        display: false,
                        beginAtZero: true,
                        color: '#FFFFFF',
                        fontColor: '#FFFFFF'
                    },
                    gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                        zeroLineColor: "rgba(255, 255, 255, 0.5)"
                    }
                }],
                xAxes: [{
                    ticks: {
                        color: '#FFFFFF',
                        fontColor: '#FFFFFF'
                    },
                    scaleLabel: {
                        display: false
                    },
                    gridLines: {
                        zeroLineWidth: 0,
                        color: "rgba(0, 0, 0, 0)",
                        zeroLineColor: "rgba(255, 255, 255, 0.5)"
                    }
                }]
            }
        }
    });

    jQuery('#num-users').on('change', function() {
        let val = jQuery(this).val();
        jQuery('.current-users').text(val);
    });

    jQuery('.roi-button').on('click', function (e) {
        e.preventDefault();
        let id = jQuery(this).attr('id');
        if (id === 'finish') {
            let current_users = +jQuery('#num-users').val();
            let quickbooks_users = +jQuery('#quickbooks-desktop-cloud').val();
            let business_cloud_users = +jQuery('#business-cloud').val();
			let totalUsers = quickbooks_users + business_cloud_users;
			let application_cloud_users = 0;
           
			if( jQuery('#application-cloud').length ) {
				application_cloud_users = +jQuery('#application-cloud').val();
				totalUsers = totalUsers + application_cloud_users;
			}

            if (current_users !== (totalUsers)) {
                jQuery('#num-users-error').text('The total number of users must be ' + current_users);
                jQuery('#num-users-error').show();
                setTimeout(() => jQuery('#num-users-error').hide(), 10000);
                return;
            }

            jQuery('#v-steps-3-tab').trigger('click');

            // DATA
            let it_hourly = +jQuery('#it-hourly-rate').val();
            let server = +jQuery('#server').val();
            let hardware = +jQuery('#hardware-cost').val();
            let setup_hours = +jQuery('#setup-hours').val();
            let terminal_services = +jQuery('#terminal-services').val();
            let server_2016 = +jQuery('#server-2016').val();
            let backup_software = +jQuery('#backup-software').val();
            let server_maintenance_hours = +jQuery('#server-maintenance-hours').val();
            let tech_support_hours = +jQuery('#tech-support-hours').val();
            let data_server_maintenance = +jQuery('#data-server-maintenance').val();

            // CALCULATIONS
            let monthly_hardware_costs = (server + hardware + (setup_hours * it_hourly)) / 36;
            let monthly_server_ops_costs = ((terminal_services + server_2016 + backup_software) *
                current_users) / 36;
            let monthly_maintenance_and_support = (server_maintenance_hours * it_hourly) + (
                tech_support_hours * current_users * it_hourly) + data_server_maintenance;
            let total_monthly_costs = monthly_hardware_costs + monthly_server_ops_costs +
                monthly_maintenance_and_support;

			const $roiCalcWrapper = jQuery( '.js-roi-calculator' );
			let qbd_price = $roiCalcWrapper.attr( 'data-price-qbd' );
			let bc_price = $roiCalcWrapper.attr( 'data-price-bc' );
            const ac_price = $roiCalcWrapper.attr('data-price-ac');
			const calculatorType = $roiCalcWrapper.attr( 'data-calculator-type' );

			if( calculatorType === 'lacerte' && current_users > 3 ) {
				qbd_price = 99;
				bc_price = 99;
            }

            let qb_cost = (qbd_price * quickbooks_users);
            let bc_cost = (bc_price * business_cloud_users);
            let ac_cost = 0;

			if( ac_price ) {
				ac_cost = (ac_price * application_cloud_users);
			}

			let rn_total = qb_cost + bc_cost + ac_cost;
            let savings_per_month = total_monthly_costs - rn_total;

            // DISPLAY

            // CLEAR
            jQuery('#roi-calc-on-premise-costs').text("TBD");
            jQuery('#roi-calc-cloud-hosted-costs').text("TBD");
            jQuery('#roi-calc-monthly-savings').text("TBD");
            jQuery('#roi-calc-on-premise-costs-per-user').text("");
            jQuery('#roi-calc-cloud-hosted-costs-per-user').text("");
            jQuery('#roi-calc-monthly-savings-per-user').text("");

            if (current_users > 0) {
                jQuery('#roi-calc-on-premise-costs-per-user').text(formatNum(total_monthly_costs / current_users));
                jQuery('#roi-calc-cloud-hosted-costs-per-user').text(formatNum(rn_total / current_users));
                jQuery('#roi-calc-monthly-savings-per-user').text(formatNum(savings_per_month / current_users));

                jQuery('#roi-calc-on-premise-costs-per-user').show();
                jQuery('#roi-calc-cloud-hosted-costs-per-user').show();
                jQuery('#roi-calc-monthly-savings-per-user').show();
            }

            jQuery('#roi-calc-on-premise-costs').text(formatNum(total_monthly_costs));
            jQuery('#roi-calc-cloud-hosted-costs').text(formatNum(rn_total));
            jQuery('#roi-calc-monthly-savings').text(formatNum(savings_per_month));

            let data = [];
            let i = 0;
            for (i = 1; i <= 12; i++) {
                data.push(roundNum(savings_per_month * i));
            }

            chart.data.datasets[0].data = data;
            chart.update();
        } else {
            switch (id) {
                case "gen-info-next":
                    closeAndOpen("#gen-info", "#hardware");
                    break;
                case "hardware-next":
                    closeAndOpen("#hardware", "#server-ops");
                    break;
                case "server-ops-next":
                    closeAndOpen("#server-ops", "#maintenance");
                    break;
                case "maintenance-next":
                    jQuery('#v-steps-2-tab').trigger('click');
                    break;
            }
        }
    });

    function closeAndOpen(close, open) {
        if (open == '#rn-user-counts') {
            jQuery(close).trigger('click');
        }
        jQuery(open).trigger('click');
    }

    function roundNum(num) {
        return Math.round((num + Number.EPSILON) * 100) / 100;
    }

    function formatNum(num) {
        let nf = new Intl.NumberFormat();
        let round = roundNum(num);
        let formatted = nf.format(round);
        let i = 0;

        if (formatted.split('.').length == 1) {
            return `$${formatted}`;
        }

        let decimal_points = formatted.split('.')[1].length;
        for (i = decimal_points; i < 2; i++)
            formatted += '0';

        return ('$' + formatted);
    }
}